module.exports = __webpack_public_path__ + "media/images/orange-5339255f.jpg";